var _style, _defs, _g, _defs2, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgTopRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 410.6 269.5",
    style: {
      enableBackground: "new 0 0 410.6 269.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.13;}\n\t.st1{clip-path:url(#SVGID_2_);}\n\t.st2{fill:#194581;}\n\t.st3{clip-path:url(#SVGID_4_);fill:#F4F4FD;}\n\t.st4{clip-path:url(#SVGID_4_);fill:#DC4B7B;}\n\t.st5{clip-path:url(#SVGID_4_);fill:#194581;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bg-top-right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 410.6,
    height: 269.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47.3,0c0,0-8.5,45.3-31.1,75s-24.7,86.8,14.1,129.7s203,73.9,380.3,62.5V0H47.3z"
  }))))))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    width: 410.6,
    height: 269.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M501.3,170.5c-25.9,3-51.8,5.7-77.6,8.9c-24.5,3-48.9,6.5-73.3,9.8c-29.2,4-58.3,8.1-87.5,11.9 c-19,2.5-38.1,4.7-59,7.2c0.8,9.3,1.5,17.9,2.3,26.6h-8.3c-0.8-8.1-1.7-16.2-2.6-25.1c-12.5,1.5-23.7,2.9-34.8,4.3v-8.3 c8.5-0.9,17.1-1.5,25.6-2.7c6.1-0.9,8.3-4,7.2-10.8c-3.7-23.7-6.7-47.5-10-71.2c-3.2-23.4-6.6-46.8-9.8-70.2 c-3.1-23.1-6-46.2-8.9-69.3h8.3c2.3,19,4.4,38.1,6.9,57.1c3.1,23.7,6.5,47.4,9.7,71.1c3.6,27.1,7.1,54.3,10.8,81.4 c0.8,5.5,3.3,9.8,10.2,8.5c8.9-1.6,17.9-3,26.9-4.4c12.5-1.3,25-2.6,37.5-3.8c8.3-1.5,16.6-3.1,25-4.6c12.5-1.2,25.1-2.4,37.6-3.7 c8.3-1.5,16.5-3.1,24.8-4.6c12.8-1.4,25.6-2.8,38.4-4.1c19-2.3,37.9-4.6,56.9-6.9c14.6-1.8,29.2-3.5,43.7-5.2V170.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M274.9,191.3c-12.5,1.3-25,2.6-37.5,3.8c-6.6-43.3-13.2-86.7-19.9-130c-1.8-11.5-3.5-23.1-5.4-35.8 c13.6-1.7,26.4-3.4,40.3-5.1c2.3,16.4,4.4,31.7,6.5,47c5.2,36.9,10.4,73.9,15.5,110.8C274.9,185.1,274.8,188.2,274.9,191.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M337.5,183.1c-12.5,1.2-25.1,2.4-37.6,3.7c-5.2-34.8-10.5-69.6-15.7-104.4c-0.3-1.7-0.4-3.4-0.9-6.4 c12.8-2.6,25.4-5.1,39.5-7.9C327.8,107.2,332.6,145.1,337.5,183.1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgTopRight);
export default __webpack_public_path__ + "static/media/bg-top-right.daa2624d8db611a589998e076f038260.svg";
export { ForwardRef as ReactComponent };